import { contactSection } from '@stereoagency/sanity-schema';
import UIContactSection from './ContactSection.client';

type Props = typeof contactSection.schema.contactSection;

export default function ContactSection({ title, description }: Props) {
  return <UIContactSection title={title} description={description} />;
}
